import type { ReactNode } from "react";
import { AdminSidebar } from "./AdminSidebar";

/**
 * Wraps the admin section as a two-column shell-content surface: a secondary
 * sub-rail (AdminSidebar) plus a wide content column. The global AppLayout
 * shell already supplies background, primary nav, and the admin entry point —
 * this layout only renders the admin-local sub-nav + body.
 */
export function AdminLayout({ children }: { children: ReactNode }) {
  return (
    <div className="mx-auto w-full max-w-[1240px] flex flex-col md:flex-row md:gap-8">
      <AdminSidebar />
      <main className="flex-1 min-w-0 px-5 sm:px-6 py-6 sm:py-8">
        {children}
      </main>
    </div>
  );
}
